import {UI} from "../../../stem-core/ui/UIBase";
import {Panel} from "../../../stem-core/ui/UIPrimitives.jsx";
import {TopLevelTabArea} from "../../../dashboard/common/theme/TabAreaStyle";
import {StepIndicator} from "../../../blinkpay/ui/StepIndicator.jsx";

// TODO Look into something like Storybook
export class TempTestingPage extends UI.Element {
    render() {
        return [
            <h1>General testing page</h1>,
            <TopLevelTabArea>
                <Panel title={"Step Indicator"}>
                    <StepIndicator />
                </Panel>
            </TopLevelTabArea>,
        ]
    }
}
